
//TODO : 
// date format
// refresh

import React from 'react';
import Moment from 'react-moment';
import { CardMedium } from '../../widgets/Cards';
//import Modal from '../../widgets/Modal';
//import Confirm from '../../widgets/Confirm';
import {connect} from 'react-redux';
//import { Form, Field} from 'react-final-form';

import { fetchVisits, fetchVisit, editVisit, newVisit, deleteVisit} from '../../../actions';

class Visit extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            showDelete : false,
            newForm : true,
            record : null,
        };
    };

    //Initial Rendering
    componentDidMount() {
        this.props.fetchVisits(this.props.patient._id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.patient._id !== prevProps.patient._id) {
                this.props.fetchVisits(this.props.patient._id)
        }   
    }

    // sorting data by date
    compareDate(a, b) {

        var key1 = a.visitdate;
        var key2 = b.visitdate;
    
        if (key1 > key2) {
            return -1;
        } else if (key1 === key2) {
            return 0;
        } else {
            return 1;
        }
    }

    renderPrivacy(content) {
        return (
            <label className="switch">
                <input type="checkbox" checked={content}/>
                <span className="slider round"></span>
            </label>
        )
    }

    renderVisitList() {

        var list = this.props.visits;
        var sortedList = list.sort(this.compareDate);

        return sortedList.map(visit =>  {
         
                return (
                        <tr key={visit._id}>
                            <td><Moment format='DD MMM YYYY'>{visit.visitdate}</Moment></td>
                            <td>{visit.reason}</td>
                            <td>{visit.provider}</td>
                            <td>{visit.meta[0].practiceID}</td>
                     
                        </tr>
                        )
        })
    }

    render() {
        return (
            <CardMedium title='Visit List' >
                <table>
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Reason</th>
                            <th>Provider</th>
                            <th>Meta</th>
                        </tr>
                    </thead>
                    <tbody> 
                        {this.renderVisitList()}
                    </tbody> 
                </table>
            </CardMedium>
        )
    }

}

const mapStateToProps = (state) => {
    return { 
        patient : state.selectedPatient,
        visits : Object.values(state.visits),
        userId : state.auth.userId,
        selectedVisit : state.selectedVisit
    }
}

export default connect(mapStateToProps, {fetchVisits, fetchVisit, editVisit, newVisit, deleteVisit})(Visit);










    








